
/**
 * 강의 콘텐츠 지원 플랫폼 환경
 */
export type CreateCourseDraft201SectionsItemLecturesItemPlatformSupport = typeof CreateCourseDraft201SectionsItemLecturesItemPlatformSupport[keyof typeof CreateCourseDraft201SectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCourseDraft201SectionsItemLecturesItemPlatformSupport = {
  IDE_ONLY: 'IDE_ONLY',
  WEB_ONLY: 'WEB_ONLY',
  IDE_AND_WEB: 'IDE_AND_WEB',
} as const;
